

exports.timerFromSeconds = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const secondsRemaining = seconds % 60;

  return minutes + ":" + (secondsRemaining < 10 ? "0" + secondsRemaining : secondsRemaining);
}